/**
 * Maps internal navigations to Next.js view-transition types (see `next.config` experimental.viewTransition).
 * Home / logo when leaving a non-home route reads as "back"; sibling top-level
 * routes use a softer lateral fade; deeper routes keep directional context.
 */
export function navLinkTransitionTypes(href: string, pathname: string | null): string[] {
  if (!pathname) return ["nav-forward"];

  const normalizedHref = normalizeInternalPath(href);
  const normalizedPathname = normalizeInternalPath(pathname);

  if (normalizedHref === "/" && normalizedPathname !== "/") return ["nav-back"];
  if (normalizedHref !== "/" && normalizedPathname === "/") return ["nav-forward"];
  if (normalizedHref === normalizedPathname) return ["nav-lateral"];

  const hrefDepth = routeDepth(normalizedHref);
  const pathnameDepth = routeDepth(normalizedPathname);
  const hrefSegment = firstSegment(normalizedHref);
  const pathnameSegment = firstSegment(normalizedPathname);

  if (hrefSegment && pathnameSegment && hrefSegment !== pathnameSegment) {
    return ["nav-lateral"];
  }

  if (hrefDepth < pathnameDepth) return ["nav-back"];

  return ["nav-forward"];
}

function normalizeInternalPath(value: string) {
  const [path] = value.split(/[?#]/);
  if (!path || !path.startsWith("/")) return value;
  if (path === "/") return "/";
  return path.replace(/\/+$/, "");
}

function firstSegment(path: string) {
  return path.split("/").filter(Boolean)[0] ?? "";
}

function routeDepth(path: string) {
  return path.split("/").filter(Boolean).length;
}
